webpackJsonp([1],{

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ = __webpack_require__(38);
var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      allPermissions: [],
      dataModel: {},
      rules: {
        name: [{ required: true, message: '角色名称不能为空', trigger: 'blur' }, { type: 'string', min: 3, message: '名称不能少于3位', trigger: 'blur' }],
        comment: [{ required: true, message: '角色备注不能为空', trigger: 'blur' }, { type: 'string', min: 2, message: '备注不能少于2位', trigger: 'blur' }]
      },
      permissionModal: false,
      editModal: false,
      destroyModal: false,
      destroyData: null,
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
      tableColumns: [{
        title: 'ID',
        key: 'id',
        align: 'center'
      }, {
        title: '角色',
        key: 'name',
        align: 'center'
      }, {
        title: '备注',
        key: 'comment',
        align: 'center'
      }, {
        title: '创建时间',
        key: 'createdAt',
        align: 'center',
        render: function render(h, params) {
          return h('span', {}, moment(params.row.createdAt).format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '更新时间',
        key: 'updatedAt',
        align: 'center',
        render: function render(h, params) {
          return h('span', {}, moment(params.row.updatedAt).format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '操作',
        key: 'actions',
        align: 'center',
        render: function (h, params) {
          return h('div', [h('Button', {
            props: {
              type: 'primary',
              size: 'small',
              disabled: params.row.name && (params.row.name === 'admin' || params.row.name === 'member')
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: function () {
                this.showEdit(params.index);
              }.bind(this)
            }
          }, '编辑'), h('Button', {
            props: {
              type: 'warning',
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: function () {
                this.showEditPermissions(params.index);
              }.bind(this)
            }
          }, '权限'), h('Button', {
            props: {
              type: 'error',
              size: 'small',
              disabled: params.row.name && (params.row.name === 'admin' || params.row.name === 'member')
            },
            on: {
              click: function () {
                this.showDestroy(params.index);
              }.bind(this)
            }
          }, '删除')]);
        }.bind(this)
      }]
    };
  },
  created: function created() {
    var _this = this;

    this.changePage(1);
    this.$http.get('admin/permissions?limit=1000').then(function (res) {
      var data = res.data.data;
      _this.allPermissions = data.rows;
    });
  },

  methods: {
    changePage: function changePage(page) {
      var _this2 = this;

      this.currentPage = page;
      this.$http.get('admin/roles?limit=10&offset=' + ((page || 1) - 1) * this.pageSize).then(function (res) {
        var data = res.data.data;
        _this2.tableData = data.rows;
        _this2.totalCount = data.count;
      });
    },
    showCreate: function showCreate() {
      this.dataModel = {};
      this.editModal = true;
    },
    showEditPermissions: function showEditPermissions(index) {
      var data = this.tableData[index];
      this.dataModel.id = data.id;
      var allPermissions = this.allPermissions;
      var userPermissions = data.permissions;
      _.forEach(allPermissions, function (permission) {
        permission.selected = false;
        _.forEach(userPermissions, function (userPermission) {
          if (permission.name === userPermission.name) {
            permission.selected = true;
            return false;
          }
        });
      });
      this.dataModel.permissions = allPermissions;
      this.permissionModal = true;
    },
    editPermission: function editPermission(result) {
      var _this3 = this;

      if (result) {
        var permissions = [];
        _.forEach(this.dataModel.permissions, function (permission) {
          if (permission.selected) {
            permissions.push(permission.name);
          }
        });
        this.$http.put('admin/roles/' + this.dataModel.id + '/permissions', {
          permissions: permissions
        }).then(function () {
          _this3.$Message.success('更新成功!');
          _this3.refresh();
        });
      }
      this.permissionModal = false;
    },
    showDestroy: function showDestroy(index) {
      this.destroyData = this.tableData[index];
      this.destroyModal = true;
    },
    destroy: function destroy(result) {
      var _this4 = this;

      if (result && this.destroyData) {
        this.$http.delete('admin/roles/' + this.destroyData.id).then(function () {
          _this4.$Message.success('删除成功!');
          _this4.refresh();
        });
      }
      this.destroyModal = false;
    },
    refresh: function refresh() {
      if (this.currentPage) {
        this.changePage(this.currentPage);
      }
    },
    showEdit: function showEdit(index) {
      var data = this.tableData[index];
      this.dataModel.id = data.id;
      this.dataModel.name = data.name;
      this.dataModel.comment = data.comment;
      this.editModal = true;
    },
    edit: function edit(result) {
      var _this5 = this;

      if (result) {
        this.$refs['dataModel'].validate(function (valid) {
          if (valid) {
            var dataId = _this5.dataModel.id;
            if (dataId) {
              // 编辑
              _this5.$http.put('admin/roles/' + dataId, {
                name: _this5.dataModel.name || undefined,
                comment: _this5.dataModel.comment || undefined
              }).then(function () {
                _this5.$Message.success('编辑成功!');
                _this5.refresh();
              });
            } else {
              // 新增
              _this5.$http.post('admin/roles', {
                name: _this5.dataModel.name || undefined,
                comment: _this5.dataModel.comment || undefined
              }).then(function () {
                _this5.$Message.success('新增成功!');
                _this5.refresh();
              });
            }
          } else {
            _this5.$Message.error('表单验证失败!');
          }
        });
      } else {
        // TODO - 页面值不会被重置 - https://github.com/iview/iview/issues/970
        // this.$refs['dataModel'].resetFields();
      }
    }
  }
});

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ = __webpack_require__(38);
var moment = __webpack_require__(0);

var defaultPermissions = ['dashboard', 'admin', 'admin:user', 'admin:role', 'admin:permission'];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dataModel: {},
      rules: {
        name: [{ required: true, message: '角色名称不能为空', trigger: 'blur' }, { type: 'string', min: 3, message: '名称不能少于3位', trigger: 'blur' }],
        comment: [{ required: true, message: '角色备注不能为空', trigger: 'blur' }, { type: 'string', min: 2, message: '备注不能少于2位', trigger: 'blur' }]
      },
      editModal: false,
      destroyModal: false,
      destroyData: null,
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
      tableColumns: [{
        title: 'ID',
        key: 'id',
        align: 'center'
      }, {
        title: '角色',
        key: 'name',
        align: 'center'
      }, {
        title: '备注',
        key: 'comment',
        align: 'center'
      }, {
        title: '创建时间',
        key: 'createdAt',
        align: 'center',
        render: function render(h, params) {
          return h('span', {}, moment(params.row.createdAt).format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '更新时间',
        key: 'updatedAt',
        align: 'center',
        render: function render(h, params) {
          return h('span', {}, moment(params.row.updatedAt).format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '操作',
        key: 'actions',
        align: 'center',
        render: function (h, params) {
          return h('div', [h('Button', {
            props: {
              type: 'primary',
              size: 'small',
              disabled: params.row.name && _.includes(defaultPermissions, params.row.name)
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: function () {
                this.showEdit(params.index);
              }.bind(this)
            }
          }, '编辑'), h('Button', {
            props: {
              type: 'error',
              size: 'small',
              disabled: params.row.name && _.includes(defaultPermissions, params.row.name)
            },
            on: {
              click: function () {
                this.showDestroy(params.index);
              }.bind(this)
            }
          }, '删除')]);
        }.bind(this)
      }]
    };
  },
  created: function created() {
    this.changePage(1);
  },

  methods: {
    changePage: function changePage(page) {
      var _this = this;

      this.currentPage = page;
      this.$http.get('admin/permissions?limit=10&offset=' + ((page || 1) - 1) * this.pageSize).then(function (res) {
        var data = res.data.data;
        _this.tableData = data.rows;
        _this.totalCount = data.count;
      });
    },
    showCreate: function showCreate() {
      this.dataModel = {};
      this.editModal = true;
    },
    showDestroy: function showDestroy(index) {
      this.destroyData = this.tableData[index];
      this.destroyModal = true;
    },
    destroy: function destroy(result) {
      var _this2 = this;

      if (result && this.destroyData) {
        this.$http.delete('admin/permissions/' + this.destroyData.id).then(function () {
          _this2.$Message.success('删除成功!');
          _this2.refresh();
        });
      }
      this.destroyModal = false;
    },
    refresh: function refresh() {
      if (this.currentPage) {
        this.changePage(this.currentPage);
      }
    },
    showEdit: function showEdit(index) {
      var data = this.tableData[index];
      this.dataModel.id = data.id;
      this.dataModel.name = data.name;
      this.dataModel.comment = data.comment;
      this.editModal = true;
    },
    edit: function edit(result) {
      var _this3 = this;

      if (result) {
        this.$refs['dataModel'].validate(function (valid) {
          if (valid) {
            var dataId = _this3.dataModel.id;
            if (dataId) {
              // 编辑
              _this3.$http.put('admin/permissions/' + dataId, {
                name: _this3.dataModel.name || undefined,
                comment: _this3.dataModel.comment || undefined
              }).then(function () {
                _this3.$Message.success('编辑成功!');
                _this3.refresh();
              });
            } else {
              // 新增
              _this3.$http.post('admin/permissions', {
                name: _this3.dataModel.name || undefined,
                comment: _this3.dataModel.comment || undefined
              }).then(function () {
                _this3.$Message.success('新增成功!');
                _this3.refresh();
              });
            }
          } else {
            _this3.$Message.error('表单验证失败!');
          }
        });
      } else {
        // TODO - 页面值不会被重置 - https://github.com/iview/iview/issues/970
        // this.$refs['dataModel'].resetFields();
      }
    }
  }
});

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      configPublicBaseOrigin: '',
      configShortPrefix: 'r',
      dismissedTip: false,
      regionTreeAll: [],
      searchKey: '',
      editModal: false,
      destroyModal: false,
      destroyData: null,
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
      listLoading: false,
      saving: false,
      deleting: false,
      tableColumns: [{ title: 'ID', key: 'id', align: 'center' }, { title: '链接名称', key: 'name', align: 'center' }, {
        title: '规则类型', key: 'rules', align: 'center',
        render: function render(h, params) {
          var rules = params.row.rules || [];
          var hasDefault = rules.find(function (r) {
            return r.type === 'default';
          });
          var condCount = rules.filter(function (r) {
            return r.type === 'conditional';
          }).length;
          var text = '' + (hasDefault ? '默认' : '') + (condCount ? (hasDefault ? '+' : '') + '条件(' + condCount + ')' : '') || '-';
          return h('span', {}, text);
        }
      }, {
        title: '目标链接', key: 'target', align: 'center',
        render: function render(h, params) {
          var rules = params.row.rules || [];
          var def = rules.find(function (r) {
            return r.type === 'default';
          });
          return h('span', {}, def && def.url || '-');
        }
      },
      // 添加访问数量列
      { title: '访问次数', key: 'visitCount', align: 'center' }, {
        title: '状态', key: 'status', align: 'center',
        render: function render(h, params) {
          var active = params.row.status === 'active';
          return h('i-switch', {
            props: { value: active },
            on: {
              'on-change': function onChange(val) {
                return _this.toggleStatus(params.index, val);
              }
            }
          });
        }
      }, { title: '创建时间', key: 'createdAt', align: 'center', render: function render(h, p) {
          return h('span', {}, __WEBPACK_IMPORTED_MODULE_4_moment___default()(p.row.createdAt).format('YYYY-MM-DD HH:mm:ss'));
        } }, {
        title: '操作', key: 'actions', align: 'center',
        render: function render(h, params) {
          var url = _this.apiOrigin + '/' + _this.shortPrefix + '/' + (params.row.shortCode || params.row.id);
          return h('div', [h('a', {
            style: { color: '#2d8cf0', cursor: 'pointer', marginRight: '8px' },
            on: { click: function click() {
                return _this.showEdit(params.index);
              } }
          }, '编辑'), h('a', {
            style: { color: '#19be6b', cursor: 'pointer', marginRight: '8px' },
            on: { click: function click() {
                return _this.copyToClipboard(url);
              } }
          }, '复制'), h('a', {
            style: { color: '#ed4014', cursor: 'pointer' },
            on: { click: function click() {
                return _this.showDestroy(params.index);
              } }
          }, '删除')]);
        }
      }],
      dataModel: { name: '', description: '', shortCode: '', rules: [], status: 'active' },
      rules: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        shortCode: [{ pattern: /^[a-zA-Z0-9]{3,20}$/, message: '短链只能包含字母和数字，长度3-20位', trigger: 'blur' }]
      }
    };
  },

  computed: {
    statusEnabled: {
      get: function get() {
        return this.dataModel.status === 'active';
      },
      set: function set(v) {
        this.dataModel.status = v ? 'active' : 'inactive';
      }
    },
    hasDefaultRule: function hasDefaultRule() {
      return !!(this.dataModel.rules || []).find(function (r) {
        return r.type === 'default';
      });
    },
    apiOrigin: function apiOrigin() {
      var root = this.$http && this.$http.options && this.$http.options.root ? this.$http.options.root : '';
      var m = root.match(/^https?:\/\/[^/]+/);
      return this.configPublicBaseOrigin || (m ? m[0] : location.origin || '');
    },
    shortPrefix: function shortPrefix() {
      return this.configShortPrefix || 'r';
    }
  },
  created: function created() {
    var _this2 = this;

    this.changePage(1);
    try {
      this.dismissedTip = !!window.localStorage.getItem('linkTipDismissed');
    } catch (e) {}
    this.$http.get('config').then(function (res) {
      var cfg = res.data && res.data.data ? res.data.data : {};
      if (cfg.baseUrl) _this2.configPublicBaseOrigin = cfg.baseUrl;
      if (cfg.prefix) _this2.configShortPrefix = cfg.prefix;
    });
    this.$http.get('regions').then(function (res) {
      var data = res.data && res.data.data ? res.data.data : {};
      var _data$tree = data.tree,
          tree = _data$tree === undefined ? [] : _data$tree;

      _this2.regionTreeAll = tree;
    });
  },

  methods: {
    doSearch: function doSearch() {
      this.changePage(1);
    },
    changePage: function changePage(page) {
      var _this3 = this;

      this.currentPage = page;
      var offset = ((page || 1) - 1) * this.pageSize;
      var q = this.searchKey ? '&q=' + encodeURIComponent(this.searchKey) : '';
      this.listLoading = true;
      this.$http.get('admin/links?limit=' + this.pageSize + '&offset=' + offset + q).then(function (res) {
        var data = res.data.data;
        _this3.tableData = data.rows || data.items || [];
        _this3.totalCount = data.count || data.total || 0;
      }).catch(function () {
        _this3.$Message.warning('列表加载失败');
      }).finally(function () {
        _this3.listLoading = false;
      });
    },
    showCreate: function showCreate() {
      this.dataModel = { name: '', description: '', shortCode: '', rules: [], status: 'active' };
      this.editModal = true;
    },
    showEdit: function showEdit(index) {
      var _this4 = this;

      var d = this.tableData[index];
      var rules = (d.rules || []).map(function (r) {
        var rt = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this4.regionTreeAll || []));
        var selected = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(r.region || []);
        var mark = function mark(nodes) {
          (nodes || []).forEach(function (n) {
            if (selected.has(n.value)) n.checked = true;
            mark(n.children);
          });
        };
        mark(rt);
        return { type: r.type, url: r.url, priority: r.priority, regions: r.region || [], regionTree: rt };
      });
      this.dataModel = { id: d.id, name: d.name, description: d.description, shortCode: d.shortCode || '', rules: rules, status: d.status };
      this.editModal = true;
    },
    showDestroy: function showDestroy(index) {
      this.destroyData = this.tableData[index];
      this.destroyModal = true;
    },
    destroy: function destroy(result) {
      var _this5 = this;

      if (result && this.destroyData) {
        this.deleting = true;
        this.$http.delete('admin/links/' + this.destroyData.id).then(function () {
          _this5.$Message.success('删除成功!');
          _this5.refresh();
        }).finally(function () {
          _this5.deleting = false;
        });
      }
      this.destroyModal = false;
    },
    refresh: function refresh() {
      if (this.currentPage) {
        this.changePage(this.currentPage);
      }
    },
    edit: function edit(result) {
      var _this6 = this;

      if (!result) return;
      this.$refs['dataModel'].validate(function (valid) {
        if (!valid) {
          _this6.$Message.error('表单验证失败!');return;
        }
        _this6.saving = true;
        var updateId = _this6.dataModel && _this6.dataModel.id;
        var payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this6.dataModel);
        delete payload.id;
        var collectChecked = function collectChecked(nodes) {
          var res = [];
          (nodes || []).forEach(function (n) {
            if (n.checked) res.push(n.value);
            res.push.apply(res, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(collectChecked(n.children)));
          });
          return res;
        };
        payload.rules = (payload.rules || []).map(function (r) {
          return { type: r.type, url: r.url, priority: r.priority || 0, region: r.type === 'conditional' ? collectChecked(r.regionTree || []) : undefined };
        });

        // 如果短链不为空，则使用自定义短链
        if (payload.shortCode) {
          payload.shortCode = payload.shortCode.trim();
        } else {
          // 如果短链为空，则删除该字段，让后端生成随机短链
          delete payload.shortCode;
        }

        if (updateId) {
          _this6.$http.put('admin/links/' + updateId, payload).then(function () {
            _this6.$Message.success('编辑成功!');_this6.refresh();
          }).catch(function () {
            _this6.$Message.warning('编辑失败');
          }).finally(function () {
            _this6.saving = false;
          });
        } else {
          _this6.$http.post('admin/links', payload).then(function () {
            _this6.$Message.success('新增成功!');_this6.refresh();
          }).catch(function () {
            _this6.$Message.warning('新增失败');
          }).finally(function () {
            _this6.saving = false;
          });
        }
      });
    },
    addDefaultRule: function addDefaultRule() {
      if (this.hasDefaultRule) return;
      this.dataModel.rules = this.dataModel.rules || [];
      this.dataModel.rules.push({ type: 'default', url: '', priority: 100 });
    },
    addConditionalRule: function addConditionalRule() {
      this.dataModel.rules = this.dataModel.rules || [];
      var rt = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.regionTreeAll || []));
      this.dataModel.rules.push({ type: 'conditional', regions: [], regionTree: rt, url: '', priority: 10 });
    },
    removeRule: function removeRule(idx) {
      this.dataModel.rules.splice(idx, 1);
    },
    expandAllRule: function expandAllRule(idx, expand) {
      var setExpand = function setExpand(nodes) {
        (nodes || []).forEach(function (n) {
          n.expand = expand;
          setExpand(n.children);
        });
      };
      var rule = this.dataModel.rules[idx];
      setExpand(rule.regionTree || []);
    },
    onRegionTreeChange: function onRegionTreeChange(idx) {
      var rule = this.dataModel.rules[idx];
      var collectChecked = function collectChecked(nodes) {
        var res = [];
        (nodes || []).forEach(function (n) {
          if (n.checked) res.push(n.value);
          res.push.apply(res, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(collectChecked(n.children)));
        });
        return res;
      };
      rule.regions = collectChecked(rule.regionTree || []);
    },
    toggleStatus: function toggleStatus(index, enabled) {
      var _this7 = this;

      var item = this.tableData[index];
      var status = enabled ? 'active' : 'inactive';
      this.$http.put('admin/links/' + item.id, { status: status }).then(function () {
        _this7.$Message.success('状态已更新');_this7.tableData[index].status = status;
      }).catch(function () {
        _this7.$Message.warning('状态更新失败');
      });
    },
    copyToClipboard: function copyToClipboard(text) {
      var _this8 = this;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () {
          return _this8.$Message.success('已复制入口链接');
        });
      } else {
        var ta = document.createElement('textarea');
        ta.value = text;
        document.body.appendChild(ta);
        ta.select();
        try {
          document.execCommand('copy');this.$Message.success('已复制入口链接');
        } catch (e) {
          this.$Message.warning('复制失败');
        }
        document.body.removeChild(ta);
      }
      try {
        window.localStorage.setItem('linkTipDismissed', '1');this.dismissedTip = true;
      } catch (e) {}
    }
  }
});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      stats: {},
      topLinks: [],
      ruleHitsByUrl: [],
      ruleDetails: []
    };
  },
  created: function created() {
    this.loadStats();
  },

  methods: {
    loadStats: function loadStats() {
      var _this = this;

      this.loading = true;
      this.$http.get('admin/links/stats').then(function (res) {
        var data = res.data.data || {};
        _this.stats = data;
        _this.topLinks = data.topLinks || [];
        _this.ruleHitsByUrl = data.ruleHits && data.ruleHits.ruleHitsByUrl || [];
        _this.ruleDetails = data.ruleHits && data.ruleHits.ruleDetails || [];
      }).catch(function () {
        _this.$Message.warning('统计信息加载失败');
      }).finally(function () {
        _this.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_view_design_dist_styles_iview_css__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_view_design_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_view_design_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_view_design__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_view_design___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_view_design__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event_bus__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_index_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









// 引入 Element UI



__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_view_design___default.a);
// 使用 Element UI
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

// 动态设置API根地址
// 首先尝试从window全局配置获取，否则使用相对路径
var apiRoot = window.APP_CONFIG && window.APP_CONFIG.apiRoot ? window.APP_CONFIG.apiRoot : '/api/v1';
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.options.root = apiRoot;

// 获取后端配置
function fetchBackendConfig() {
  // 使用原生fetch来获取初始配置，避免Vue实例未准备好的问题
  return fetch('/api/v1/config').then(function (res) {
    return res.json();
  }).then(function (data) {
    var cfg = data && data.data ? data.data : {};
    if (cfg.baseUrl) {
      // 使用后端返回的baseUrl
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.options.root = cfg.baseUrl + '/api/v1';
      console.log('API root set to:', __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.options.root);
    }
  }).catch(function (err) {
    console.warn('Failed to fetch backend config, using default:', err);
  });
}

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.interceptors.push(function (request, next) {
  request.credentials = true; // 允许发送cookie

  this.$Loading.start();

  next(function (response) {
    // 处理http请求异常
    var data = response.data;
    if (data && data.code > 0) {
      this.$Message.warning({
        content: data.message || '后台未知错误',
        duration: 5
      });
      this.$Loading.error();
    } else if (response && response.status !== 200) {
      var message = response.statusText;
      switch (response.status) {
        case 404:
          message = '页面或接口不存在!';
          break;
        case 500:
          message = '服务器内部错误!';
          break;
        default:
          break;
      }
      this.$Message.warning({
        content: message || '后台未知错误',
        duration: 5
      });
      this.$Loading.error();
    } else {
      this.$Loading.finish();
    }
  });
});

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: {
    user: {
      userInfo: null,
      roles: [],
      permissions: []
    }
  },
  mutations: {
    /* eslint-disable */
    clearUser: function clearUser(state) {
      state.user.userInfo = null;
      state.user.roles = [];
      state.user.permissions = [];
    },
    updateUser: function updateUser(state, data) {
      if (data.id && data.username) {
        state.user.userInfo = {
          id: data.id,
          username: data.username
        };
        state.user.roles = data.roles || [];
        state.user.permissions = data.permissions || [];
      }
    }
  }
});

__WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].beforeEach(function (to, from, next) {
  var path = to.path.substr(1);
  var pathPermission = path.split('/').join(':');
  var permissions = store.state.user.permissions || [];
  if (permissions.indexOf(pathPermission) < 0) {
    // 禁止访问无权限页面
    next(false);
  } else {
    next();
  }
});

__WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].afterEach(function (to, from) {
  __WEBPACK_IMPORTED_MODULE_6__event_bus__["a" /* default */].$emit('route-change', {
    to: to,
    from: from
  });
});

// 获取配置后启动应用
fetchBackendConfig().then(function () {
  new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
    el: '#app',
    store: store,
    router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] }
  });
}).catch(function () {
  // 如果获取配置失败，仍然启动应用
  new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
    el: '#app',
    store: store,
    router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] }
  });
});
/* eslint-enable */

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(65);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bc157c4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(269);
function injectStyle (ssrContext) {
  __webpack_require__(256)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bc157c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bc157c4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 256:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenu_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8dbe232_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__ = __webpack_require__(259);
function injectStyle (ssrContext) {
  __webpack_require__(258)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b8dbe232"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8dbe232_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 258:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"default-active":_vm.activeMenu,"background-color":"#464c5b","text-color":"#fff","active-text-color":"#ffd04b","unique-opened":true,"collapse":false},on:{"select":_vm.routeTo}},[_c('div',{staticClass:"layout-logo-left"},[_vm._v("惠民中台")]),_vm._v(" "),(_vm.permissions['dashboard'])?_c('el-menu-item',{attrs:{"index":"dashboard"}},[_c('i',{staticClass:"el-icon-monitor"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.permissions['dashboard'].menuName))])]):_vm._e(),_vm._v(" "),(_vm.permissions['admin'])?_c('el-submenu',{attrs:{"index":"admin"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-setting"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.permissions['admin'].menuName))])]),_vm._v(" "),(_vm.permissions['admin:user'])?_c('el-menu-item',{attrs:{"index":"admin:user"}},[_vm._v(_vm._s(_vm.permissions['admin:user'].menuName))]):_vm._e(),_vm._v(" "),(_vm.permissions['admin:role'])?_c('el-menu-item',{attrs:{"index":"admin:role"}},[_vm._v(_vm._s(_vm.permissions['admin:role'].menuName))]):_vm._e(),_vm._v(" "),(_vm.permissions['admin:permission'])?_c('el-menu-item',{attrs:{"index":"admin:permission"}},[_vm._v(_vm._s(_vm.permissions['admin:permission'].menuName))]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.permissions['link'])?_c('el-submenu',{attrs:{"index":"link"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-link"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.permissions['link'].menuName))])]),_vm._v(" "),(_vm.permissions['link:dynamic'])?_c('el-menu-item',{attrs:{"index":"link:dynamic"}},[_vm._v(_vm._s(_vm.permissions['link:dynamic'].menuName))]):_vm._e(),_vm._v(" "),(_vm.permissions['link:stats'])?_c('el-menu-item',{attrs:{"index":"link:stats"}},[_vm._v(_vm._s(_vm.permissions['link:stats'].menuName))]):_vm._e()],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigator_vue__ = __webpack_require__(67);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_787e819c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigator_vue__ = __webpack_require__(262);
function injectStyle (ssrContext) {
  __webpack_require__(261)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-787e819c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_787e819c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 261:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-breadcrumb"},[_c('Breadcrumb',_vm._l((_vm.itemNames),function(itemName){return _c('Breadcrumb-item',{key:itemName},[_vm._v(_vm._s(itemName))])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopMenu_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a225952_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopMenu_vue__ = __webpack_require__(265);
function injectStyle (ssrContext) {
  __webpack_require__(264)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a225952"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a225952_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 264:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-menu"},[_c('Dropdown',{attrs:{"trigger":"click"},on:{"on-click":_vm.action}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('Icon',{attrs:{"type":"ios-person","size":"18"}}),_vm._v(" "),_c('Icon',{attrs:{"type":"ios-arrow-down","size":"18"}})],1),_vm._v(" "),_c('Dropdown-menu',{attrs:{"slot":"list"},slot:"list"},[_c('Dropdown-item',{attrs:{"name":"password"}},[_vm._v("修改密码")]),_vm._v(" "),_c('Dropdown-item',{attrs:{"name":"logout"}},[_vm._v("登出")])],1)],1),_vm._v(" "),_c('Modal',{attrs:{"width":"400","title":"修改密码"},on:{"on-ok":function($event){return _vm.confirm(true)},"on-cancel":function($event){return _vm.confirm(false)}},model:{value:(_vm.passwordModal),callback:function ($$v) {_vm.passwordModal=$$v},expression:"passwordModal"}},[_c('Form',{ref:"dataModel",attrs:{"model":_vm.dataModel,"rules":_vm.rules,"label-width":100}},[_c('Form-item',{attrs:{"label":"原密码","prop":"oldPassword"}},[_c('Input',{attrs:{"type":"password","placeholder":"请输入原密码"},model:{value:(_vm.dataModel.oldPassword),callback:function ($$v) {_vm.$set(_vm.dataModel, "oldPassword", $$v)},expression:"dataModel.oldPassword"}})],1),_vm._v(" "),_c('Form-item',{attrs:{"label":"新密码","prop":"newPassword"}},[_c('Input',{attrs:{"type":"password","placeholder":"请输入新密码"},model:{value:(_vm.dataModel.newPassword),callback:function ($$v) {_vm.$set(_vm.dataModel, "newPassword", $$v)},expression:"dataModel.newPassword"}})],1),_vm._v(" "),_c('Form-item',{attrs:{"label":"重复新密码","prop":"newPasswordRepeat"}},[_c('Input',{attrs:{"type":"password","placeholder":"请重复新密码"},model:{value:(_vm.dataModel.newPasswordRepeat),callback:function ($$v) {_vm.$set(_vm.dataModel, "newPasswordRepeat", $$v)},expression:"dataModel.newPasswordRepeat"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(70);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a2599e2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(268);
function injectStyle (ssrContext) {
  __webpack_require__(267)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a2599e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a2599e2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 267:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-container"},[_c('el-card',{staticClass:"login-card"},[_c('div',{staticClass:"login-header",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("用户查询")])]),_vm._v(" "),_c('el-form',{ref:"formLogin",attrs:{"model":_vm.formLogin,"rules":_vm.ruleCustom,"label-width":"60px"}},[_c('el-form-item',{attrs:{"label":"用户","prop":"username"}},[_c('el-input',{attrs:{"placeholder":"请输入用户名"},model:{value:(_vm.formLogin.username),callback:function ($$v) {_vm.$set(_vm.formLogin, "username", $$v)},expression:"formLogin.username"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"密码","prop":"password"}},[_c('el-input',{attrs:{"type":"password","placeholder":"请输入密码"},model:{value:(_vm.formLogin.password),callback:function ($$v) {_vm.$set(_vm.formLogin, "password", $$v)},expression:"formLogin.password"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.handleSubmit('formLogin')}}},[_vm._v("登录")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-section",staticStyle:{"height":"100%","min-height":"100%"}},[(_vm.notLogin)?_c('login-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.loginSettle),expression:"loginSettle"}]}):_c('div',{staticClass:"layout"},[_c('el-container',{staticStyle:{"height":"100%","min-height":"100%"}},[_c('el-aside',{staticClass:"layout-menu-left",attrs:{"width":"200px"}},[_c('side-menu',{attrs:{"permissions":_vm.permissions}})],1),_vm._v(" "),_c('el-container',[_c('el-header',{staticClass:"layout-header"},[_c('el-row',[_c('el-col',{attrs:{"span":22}},[_vm._v(" ")]),_vm._v(" "),_c('el-col',{staticClass:"top-menu-section",attrs:{"span":2}},[_c('top-menu')],1)],1)],1),_vm._v(" "),_c('navigator'),_vm._v(" "),_c('el-main',[(_vm.errorMessage && _vm.errorMessage.length)?_c('div',{staticClass:"error-wrapper"},[_c('el-alert',{attrs:{"title":_vm.errorMessage,"type":"warning","show-icon":"","closable":false}})],1):_vm._e(),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('el-footer',{staticClass:"layout-copy"},[_vm._v("test")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_User__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_Role__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_Permission__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_Link__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_Stats__ = __webpack_require__(324);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/dashboard',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Dashboard__["a" /* default */]
  }, {
    path: '/admin/user',
    component: __WEBPACK_IMPORTED_MODULE_3__components_admin_User__["a" /* default */]
  }, {
    path: '/admin/role',
    component: __WEBPACK_IMPORTED_MODULE_4__components_admin_Role__["a" /* default */]
  }, {
    path: '/admin/permission',
    component: __WEBPACK_IMPORTED_MODULE_5__components_admin_Permission__["a" /* default */]
  }, {
    path: '/link/dynamic',
    component: __WEBPACK_IMPORTED_MODULE_6__components_admin_Link__["a" /* default */]
  }, {
    path: '/link/stats',
    component: __WEBPACK_IMPORTED_MODULE_7__components_admin_Stats__["a" /* default */]
  }]
}));

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d0ce818_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(274);
function injectStyle (ssrContext) {
  __webpack_require__(273)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9d0ce818"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d0ce818_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 273:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-container"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('el-card',{staticClass:"dashboard-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Welcome")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('p',[_vm._v("Welcome, user "),_c('b',[_vm._v(_vm._s(_vm.userInfo.username))])])])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-card',{staticClass:"dashboard-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Your Roles")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},_vm._l((_vm.roles),function(role){return _c('p',{key:role},[_vm._v(_vm._s(role))])}),0)])],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-card',{staticClass:"dashboard-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Your Permissions")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},_vm._l((_vm.permissions),function(permission){return _c('p',{key:permission},[_vm._v(_vm._s(permission))])}),0)])],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-card',{staticClass:"dashboard-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Todos")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('p',[_vm._v("TODO1")]),_vm._v(" "),_c('p',[_vm._v("TODO2")]),_vm._v(" "),_c('p',[_vm._v("TODO3")])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4b4789c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__ = __webpack_require__(278);
function injectStyle (ssrContext) {
  __webpack_require__(276)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b4b4789c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4b4789c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 276:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 73,
	"./af.js": 73,
	"./ar": 74,
	"./ar-dz": 75,
	"./ar-dz.js": 75,
	"./ar-kw": 76,
	"./ar-kw.js": 76,
	"./ar-ly": 77,
	"./ar-ly.js": 77,
	"./ar-ma": 78,
	"./ar-ma.js": 78,
	"./ar-ps": 79,
	"./ar-ps.js": 79,
	"./ar-sa": 80,
	"./ar-sa.js": 80,
	"./ar-tn": 81,
	"./ar-tn.js": 81,
	"./ar.js": 74,
	"./az": 82,
	"./az.js": 82,
	"./be": 83,
	"./be.js": 83,
	"./bg": 84,
	"./bg.js": 84,
	"./bm": 85,
	"./bm.js": 85,
	"./bn": 86,
	"./bn-bd": 87,
	"./bn-bd.js": 87,
	"./bn.js": 86,
	"./bo": 88,
	"./bo.js": 88,
	"./br": 89,
	"./br.js": 89,
	"./bs": 90,
	"./bs.js": 90,
	"./ca": 91,
	"./ca.js": 91,
	"./cs": 92,
	"./cs.js": 92,
	"./cv": 93,
	"./cv.js": 93,
	"./cy": 94,
	"./cy.js": 94,
	"./da": 95,
	"./da.js": 95,
	"./de": 96,
	"./de-at": 97,
	"./de-at.js": 97,
	"./de-ch": 98,
	"./de-ch.js": 98,
	"./de.js": 96,
	"./dv": 99,
	"./dv.js": 99,
	"./el": 100,
	"./el.js": 100,
	"./en-au": 101,
	"./en-au.js": 101,
	"./en-ca": 102,
	"./en-ca.js": 102,
	"./en-gb": 103,
	"./en-gb.js": 103,
	"./en-ie": 104,
	"./en-ie.js": 104,
	"./en-il": 105,
	"./en-il.js": 105,
	"./en-in": 106,
	"./en-in.js": 106,
	"./en-nz": 107,
	"./en-nz.js": 107,
	"./en-sg": 108,
	"./en-sg.js": 108,
	"./eo": 109,
	"./eo.js": 109,
	"./es": 110,
	"./es-do": 111,
	"./es-do.js": 111,
	"./es-mx": 112,
	"./es-mx.js": 112,
	"./es-us": 113,
	"./es-us.js": 113,
	"./es.js": 110,
	"./et": 114,
	"./et.js": 114,
	"./eu": 115,
	"./eu.js": 115,
	"./fa": 116,
	"./fa.js": 116,
	"./fi": 117,
	"./fi.js": 117,
	"./fil": 118,
	"./fil.js": 118,
	"./fo": 119,
	"./fo.js": 119,
	"./fr": 120,
	"./fr-ca": 121,
	"./fr-ca.js": 121,
	"./fr-ch": 122,
	"./fr-ch.js": 122,
	"./fr.js": 120,
	"./fy": 123,
	"./fy.js": 123,
	"./ga": 124,
	"./ga.js": 124,
	"./gd": 125,
	"./gd.js": 125,
	"./gl": 126,
	"./gl.js": 126,
	"./gom-deva": 127,
	"./gom-deva.js": 127,
	"./gom-latn": 128,
	"./gom-latn.js": 128,
	"./gu": 129,
	"./gu.js": 129,
	"./he": 130,
	"./he.js": 130,
	"./hi": 131,
	"./hi.js": 131,
	"./hr": 132,
	"./hr.js": 132,
	"./hu": 133,
	"./hu.js": 133,
	"./hy-am": 134,
	"./hy-am.js": 134,
	"./id": 135,
	"./id.js": 135,
	"./is": 136,
	"./is.js": 136,
	"./it": 137,
	"./it-ch": 138,
	"./it-ch.js": 138,
	"./it.js": 137,
	"./ja": 139,
	"./ja.js": 139,
	"./jv": 140,
	"./jv.js": 140,
	"./ka": 141,
	"./ka.js": 141,
	"./kk": 142,
	"./kk.js": 142,
	"./km": 143,
	"./km.js": 143,
	"./kn": 144,
	"./kn.js": 144,
	"./ko": 145,
	"./ko.js": 145,
	"./ku": 146,
	"./ku-kmr": 147,
	"./ku-kmr.js": 147,
	"./ku.js": 146,
	"./ky": 148,
	"./ky.js": 148,
	"./lb": 149,
	"./lb.js": 149,
	"./lo": 150,
	"./lo.js": 150,
	"./lt": 151,
	"./lt.js": 151,
	"./lv": 152,
	"./lv.js": 152,
	"./me": 153,
	"./me.js": 153,
	"./mi": 154,
	"./mi.js": 154,
	"./mk": 155,
	"./mk.js": 155,
	"./ml": 156,
	"./ml.js": 156,
	"./mn": 157,
	"./mn.js": 157,
	"./mr": 158,
	"./mr.js": 158,
	"./ms": 159,
	"./ms-my": 160,
	"./ms-my.js": 160,
	"./ms.js": 159,
	"./mt": 161,
	"./mt.js": 161,
	"./my": 162,
	"./my.js": 162,
	"./nb": 163,
	"./nb.js": 163,
	"./ne": 164,
	"./ne.js": 164,
	"./nl": 165,
	"./nl-be": 166,
	"./nl-be.js": 166,
	"./nl.js": 165,
	"./nn": 167,
	"./nn.js": 167,
	"./oc-lnc": 168,
	"./oc-lnc.js": 168,
	"./pa-in": 169,
	"./pa-in.js": 169,
	"./pl": 170,
	"./pl.js": 170,
	"./pt": 171,
	"./pt-br": 172,
	"./pt-br.js": 172,
	"./pt.js": 171,
	"./ro": 173,
	"./ro.js": 173,
	"./ru": 174,
	"./ru.js": 174,
	"./sd": 175,
	"./sd.js": 175,
	"./se": 176,
	"./se.js": 176,
	"./si": 177,
	"./si.js": 177,
	"./sk": 178,
	"./sk.js": 178,
	"./sl": 179,
	"./sl.js": 179,
	"./sq": 180,
	"./sq.js": 180,
	"./sr": 181,
	"./sr-cyrl": 182,
	"./sr-cyrl.js": 182,
	"./sr.js": 181,
	"./ss": 183,
	"./ss.js": 183,
	"./sv": 184,
	"./sv.js": 184,
	"./sw": 185,
	"./sw.js": 185,
	"./ta": 186,
	"./ta.js": 186,
	"./te": 187,
	"./te.js": 187,
	"./tet": 188,
	"./tet.js": 188,
	"./tg": 189,
	"./tg.js": 189,
	"./th": 190,
	"./th.js": 190,
	"./tk": 191,
	"./tk.js": 191,
	"./tl-ph": 192,
	"./tl-ph.js": 192,
	"./tlh": 193,
	"./tlh.js": 193,
	"./tr": 194,
	"./tr.js": 194,
	"./tzl": 195,
	"./tzl.js": 195,
	"./tzm": 196,
	"./tzm-latn": 197,
	"./tzm-latn.js": 197,
	"./tzm.js": 196,
	"./ug-cn": 198,
	"./ug-cn.js": 198,
	"./uk": 199,
	"./uk.js": 199,
	"./ur": 200,
	"./ur.js": 200,
	"./uz": 201,
	"./uz-latn": 202,
	"./uz-latn.js": 202,
	"./uz.js": 201,
	"./vi": 203,
	"./vi.js": 203,
	"./x-pseudo": 204,
	"./x-pseudo.js": 204,
	"./yo": 205,
	"./yo.js": 205,
	"./zh-cn": 206,
	"./zh-cn.js": 206,
	"./zh-hk": 207,
	"./zh-hk.js": 207,
	"./zh-mo": 208,
	"./zh-mo.js": 208,
	"./zh-tw": 209,
	"./zh-tw.js": 209
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 277;

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-user-view"},[_c('Card',{attrs:{"dis-hover":""}},[_c('Row',{staticClass:"table-action-section",attrs:{"type":"flex","justify":"center"}},[_c('Col',{attrs:{"span":"22"}},[_c('b',[_vm._v("用户列表")])]),_vm._v(" "),_c('Col',{attrs:{"span":"2"}},[_c('Button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.showCreate}},[_vm._v("新增")])],1)],1),_vm._v(" "),_c('Table',{attrs:{"border":"","data":_vm.tableData,"columns":_vm.tableColumns,"stripe":""}}),_vm._v(" "),_c('div',{staticStyle:{"margin":"10px","overflow":"hidden"}},[_c('div',{staticStyle:{"float":"right"}},[_c('Page',{attrs:{"show-total":"","total":_vm.totalCount,"page-size":_vm.pageSize},on:{"on-change":_vm.changePage}})],1)])],1),_vm._v(" "),_c('Modal',{attrs:{"width":"400","title":"编辑用户信息"},on:{"on-ok":function($event){return _vm.edit(true)},"on-cancel":function($event){return _vm.edit(false)}},model:{value:(_vm.editModal),callback:function ($$v) {_vm.editModal=$$v},expression:"editModal"}},[_c('Form',{ref:"dataModel",attrs:{"model":_vm.dataModel,"rules":_vm.rules,"label-width":80}},[_c('Form-item',{attrs:{"label":"姓名","prop":"username"}},[_c('Input',{attrs:{"placeholder":"请输入姓名","disabled":_vm.dataModel.username === 'admin'},model:{value:(_vm.dataModel.username),callback:function ($$v) {_vm.$set(_vm.dataModel, "username", $$v)},expression:"dataModel.username"}})],1),_vm._v(" "),_c('Form-item',{attrs:{"label":"密码","prop":"password"}},[_c('Input',{attrs:{"placeholder":"********"},model:{value:(_vm.dataModel.password),callback:function ($$v) {_vm.$set(_vm.dataModel, "password", $$v)},expression:"dataModel.password"}})],1),_vm._v(" "),_c('Form-item',{attrs:{"label":"启用","prop":"enabled"}},[_c('i-switch',{attrs:{"disabled":_vm.dataModel.username === 'admin'},model:{value:(_vm.dataModel.enabled),callback:function ($$v) {_vm.$set(_vm.dataModel, "enabled", $$v)},expression:"dataModel.enabled"}})],1),_vm._v(" "),_c('Form-item',{attrs:{"label":"角色"}},[_c('Checkbox-group',_vm._l((_vm.allRoles),function(role){return _c('Checkbox',{key:role.name,attrs:{"label":role.name,"disabled":_vm.dataModel.username === role.name},model:{value:(role.selected),callback:function ($$v) {_vm.$set(role, "selected", $$v)},expression:"role.selected"}})}),1)],1)],1)],1),_vm._v(" "),_c('Modal',{attrs:{"width":"300"},model:{value:(_vm.destroyModal),callback:function ($$v) {_vm.destroyModal=$$v},expression:"destroyModal"}},[_c('p',{staticStyle:{"color":"#f60","text-align":"center"},attrs:{"slot":"header"},slot:"header"},[_c('Icon',{attrs:{"type":"information-circled"}}),_vm._v(" "),_c('span',[_vm._v("用户删除确认")])],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","font-size":"14px"}},[_c('p',[_vm._v("用户："+_vm._s(_vm.destroyData ? _vm.destroyData.username : '-'))]),_vm._v(" "),_c('p',[_vm._v("将被删除且无法恢复，是否继续？")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('Button',{attrs:{"type":"error","size":"large","long":""},on:{"click":function($event){return _vm.destroy(true)}}},[_vm._v("删除")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Role_vue__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dbebcac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Role_vue__ = __webpack_require__(281);
function injectStyle (ssrContext) {
  __webpack_require__(280)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dbebcac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Role_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dbebcac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Role_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 280:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-user-view"},[_c('Card',{attrs:{"dis-hover":""}},[_c('Row',{staticClass:"table-action-section",attrs:{"type":"flex","justify":"center"}},[_c('Col',{attrs:{"span":"22"}},[_c('b',[_vm._v("角色列表")])]),_vm._v(" "),_c('Col',{attrs:{"span":"2"}},[_c('Button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.showCreate}},[_vm._v("新增")])],1)],1),_vm._v(" "),_c('Table',{attrs:{"border":"","data":_vm.tableData,"columns":_vm.tableColumns,"stripe":""}}),_vm._v(" "),_c('div',{staticStyle:{"margin":"10px","overflow":"hidden"}},[_c('div',{staticStyle:{"float":"right"}},[_c('Page',{attrs:{"show-total":"","total":_vm.totalCount,"page-size":_vm.pageSize},on:{"on-change":_vm.changePage}})],1)])],1),_vm._v(" "),_c('Modal',{attrs:{"width":"400","title":"编辑角色信息"},on:{"on-ok":function($event){return _vm.edit(true)},"on-cancel":function($event){return _vm.edit(false)}},model:{value:(_vm.editModal),callback:function ($$v) {_vm.editModal=$$v},expression:"editModal"}},[_c('Form',{ref:"dataModel",attrs:{"model":_vm.dataModel,"rules":_vm.rules,"label-width":80}},[_c('Form-item',{attrs:{"label":"角色","prop":"name"}},[_c('Input',{attrs:{"placeholder":"请输入角色名称","disabled":_vm.dataModel.name === 'admin'},model:{value:(_vm.dataModel.name),callback:function ($$v) {_vm.$set(_vm.dataModel, "name", $$v)},expression:"dataModel.name"}})],1),_vm._v(" "),_c('Form-item',{attrs:{"label":"备注","prop":"comment"}},[_c('Input',{attrs:{"placeholder":"请输入角色备注","disabled":_vm.dataModel.name === 'admin'},model:{value:(_vm.dataModel.comment),callback:function ($$v) {_vm.$set(_vm.dataModel, "comment", $$v)},expression:"dataModel.comment"}})],1)],1)],1),_vm._v(" "),_c('Modal',{attrs:{"width":"400","title":"编辑角色权限"},on:{"on-ok":function($event){return _vm.editPermission(true)},"on-cancel":function($event){return _vm.editPermission(false)}},model:{value:(_vm.permissionModal),callback:function ($$v) {_vm.permissionModal=$$v},expression:"permissionModal"}},[_c('Form',{attrs:{"label-width":80}},[_c('Form-item',{attrs:{"label":"权限"}},[_c('Checkbox-group',_vm._l((_vm.allPermissions),function(permission){return _c('Checkbox',{key:permission.name,attrs:{"disabled":permission.name === 'dashboard',"label":permission.name},model:{value:(permission.selected),callback:function ($$v) {_vm.$set(permission, "selected", $$v)},expression:"permission.selected"}})}),1)],1)],1)],1),_vm._v(" "),_c('Modal',{attrs:{"width":"300"},model:{value:(_vm.destroyModal),callback:function ($$v) {_vm.destroyModal=$$v},expression:"destroyModal"}},[_c('p',{staticStyle:{"color":"#f60","text-align":"center"},attrs:{"slot":"header"},slot:"header"},[_c('Icon',{attrs:{"type":"information-circled"}}),_vm._v(" "),_c('span',[_vm._v("角色删除确认")])],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","font-size":"14px"}},[_c('p',[_vm._v("角色："+_vm._s(_vm.destroyData ? _vm.destroyData.name : '-'))]),_vm._v(" "),_c('p',[_vm._v("将被删除且无法恢复，是否继续？")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('Button',{attrs:{"type":"error","size":"large","long":""},on:{"click":function($event){return _vm.destroy(true)}}},[_vm._v("删除")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Permission_vue__ = __webpack_require__(211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43ba08a0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Permission_vue__ = __webpack_require__(284);
function injectStyle (ssrContext) {
  __webpack_require__(283)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43ba08a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Permission_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43ba08a0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Permission_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 283:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-user-view"},[_c('Card',{attrs:{"dis-hover":""}},[_c('Row',{staticClass:"table-action-section",attrs:{"type":"flex","justify":"center"}},[_c('Col',{attrs:{"span":"22"}},[_c('b',[_vm._v("权限列表")])]),_vm._v(" "),_c('Col',{attrs:{"span":"2"}},[_c('Button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.showCreate}},[_vm._v("新增")])],1)],1),_vm._v(" "),_c('Table',{attrs:{"border":"","data":_vm.tableData,"columns":_vm.tableColumns,"stripe":""}}),_vm._v(" "),_c('div',{staticStyle:{"margin":"10px","overflow":"hidden"}},[_c('div',{staticStyle:{"float":"right"}},[_c('Page',{attrs:{"show-total":"","total":_vm.totalCount,"page-size":_vm.pageSize},on:{"on-change":_vm.changePage}})],1)])],1),_vm._v(" "),_c('Modal',{attrs:{"width":"400","title":"编辑权限信息"},on:{"on-ok":function($event){return _vm.edit(true)},"on-cancel":function($event){return _vm.edit(false)}},model:{value:(_vm.editModal),callback:function ($$v) {_vm.editModal=$$v},expression:"editModal"}},[_c('Form',{ref:"dataModel",attrs:{"model":_vm.dataModel,"rules":_vm.rules,"label-width":80}},[_c('Form-item',{attrs:{"label":"权限","prop":"name"}},[_c('Input',{attrs:{"placeholder":"请输入权限名称"},model:{value:(_vm.dataModel.name),callback:function ($$v) {_vm.$set(_vm.dataModel, "name", $$v)},expression:"dataModel.name"}})],1),_vm._v(" "),_c('Form-item',{attrs:{"label":"备注","prop":"comment"}},[_c('Input',{attrs:{"placeholder":"请输入权限备注"},model:{value:(_vm.dataModel.comment),callback:function ($$v) {_vm.$set(_vm.dataModel, "comment", $$v)},expression:"dataModel.comment"}})],1)],1)],1),_vm._v(" "),_c('Modal',{attrs:{"width":"300"},model:{value:(_vm.destroyModal),callback:function ($$v) {_vm.destroyModal=$$v},expression:"destroyModal"}},[_c('p',{staticStyle:{"color":"#f60","text-align":"center"},attrs:{"slot":"header"},slot:"header"},[_c('Icon',{attrs:{"type":"information-circled"}}),_vm._v(" "),_c('span',[_vm._v("角色删除确认")])],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","font-size":"14px"}},[_c('p',[_vm._v("角色："+_vm._s(_vm.destroyData ? _vm.destroyData.name : '-'))]),_vm._v(" "),_c('p',[_vm._v("将被删除且无法恢复，是否继续？")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('Button',{attrs:{"type":"error","size":"large","long":""},on:{"click":function($event){return _vm.destroy(true)}}},[_vm._v("删除")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Link_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca03298e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Link_vue__ = __webpack_require__(323);
function injectStyle (ssrContext) {
  __webpack_require__(286)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ca03298e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Link_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca03298e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 286:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-link-view"},[_c('Card',{attrs:{"dis-hover":""}},[_c('Alert',{staticStyle:{"margin-bottom":"12px"},attrs:{"type":"info","show-icon":""}},[_vm._v("动态链接支持地区条件匹配与默认回退。保存后生成可复制的短链。")]),_vm._v(" "),_c('Row',{staticClass:"table-action-section",attrs:{"type":"flex","justify":"center"}},[_c('Col',{attrs:{"span":"12"}},[_c('b',[_vm._v("动态链接列表")]),_vm._v(" "),_c('Poptip',{attrs:{"trigger":"hover","placement":"right"}},[_c('Icon',{staticStyle:{"margin-left":"6px"},attrs:{"type":"md-help-circle"}}),_vm._v(" "),_c('div',{staticStyle:{"max-width":"320px","white-space":"normal"},attrs:{"slot":"content"},slot:"content"},[_vm._v("\n            动态链接支持地区条件匹配与默认回退，保存后生成可复制的短链。\n          ")])],1)],1),_vm._v(" "),_c('Col',{staticStyle:{"text-align":"right"},attrs:{"span":"8"}},[_c('Input',{staticStyle:{"width":"240px"},attrs:{"placeholder":"搜索链接名称"},on:{"on-enter":_vm.doSearch},model:{value:(_vm.searchKey),callback:function ($$v) {_vm.searchKey=$$v},expression:"searchKey"}}),_vm._v(" "),_c('Button',{staticStyle:{"margin-left":"8px"},attrs:{"type":"default","size":"small"},on:{"click":_vm.doSearch}},[_vm._v("搜索")])],1),_vm._v(" "),_c('Col',{staticStyle:{"text-align":"right"},attrs:{"span":"4"}},[_c('Button',{attrs:{"type":"primary","size":"small","disabled":_vm.listLoading,"loading":_vm.saving},on:{"click":_vm.showCreate}},[_vm._v("新增链接")])],1)],1),_vm._v(" "),_c('Table',{attrs:{"border":"","data":_vm.tableData,"columns":_vm.tableColumns,"stripe":"","loading":_vm.listLoading}}),_vm._v(" "),_c('div',{staticStyle:{"margin":"10px","overflow":"hidden"}},[_c('div',{staticStyle:{"float":"right"}},[_c('Page',{attrs:{"show-total":"","total":_vm.totalCount,"page-size":_vm.pageSize},on:{"on-change":_vm.changePage}})],1)])],1),_vm._v(" "),_c('Modal',{attrs:{"width":"960","title":"新增/编辑动态链接"},on:{"on-ok":function($event){return _vm.edit(true)},"on-cancel":function($event){return _vm.edit(false)}},model:{value:(_vm.editModal),callback:function ($$v) {_vm.editModal=$$v},expression:"editModal"}},[_c('div',{staticClass:"edit-modal-body"},[_c('Form',{ref:"dataModel",attrs:{"model":_vm.dataModel,"rules":_vm.rules,"label-width":100}},[_c('Form-item',{attrs:{"label":"链接名称","prop":"name"}},[_c('Input',{attrs:{"placeholder":"请输入名称"},model:{value:(_vm.dataModel.name),callback:function ($$v) {_vm.$set(_vm.dataModel, "name", $$v)},expression:"dataModel.name"}})],1),_vm._v(" "),_c('Form-item',{attrs:{"label":"链接描述","prop":"description"}},[_c('Input',{attrs:{"placeholder":"可选"},model:{value:(_vm.dataModel.description),callback:function ($$v) {_vm.$set(_vm.dataModel, "description", $$v)},expression:"dataModel.description"}})],1),_vm._v(" "),_c('Form-item',{attrs:{"label":"自定义短链","prop":"shortCode"}},[_c('Input',{attrs:{"placeholder":"留空则自动生成随机短链"},model:{value:(_vm.dataModel.shortCode),callback:function ($$v) {_vm.$set(_vm.dataModel, "shortCode", $$v)},expression:"dataModel.shortCode"}},[_c('span',{attrs:{"slot":"prepend"},slot:"prepend"},[_vm._v(_vm._s(_vm.apiOrigin)+"/"+_vm._s(_vm.shortPrefix)+"/")])])],1),_vm._v(" "),_c('Form-item',{attrs:{"label":"启用状态","prop":"status"}},[_c('i-switch',{model:{value:(_vm.statusEnabled),callback:function ($$v) {_vm.statusEnabled=$$v},expression:"statusEnabled"}})],1),_vm._v(" "),_c('Divider',[_vm._v("跳转规则")]),_vm._v(" "),_c('Row',[_c('Col',{attrs:{"span":"24"}},[_c('Button',{attrs:{"type":"dashed","icon":"md-add","disabled":_vm.hasDefaultRule},on:{"click":_vm.addDefaultRule}},[_vm._v("添加默认规则")]),_vm._v(" "),_c('Button',{staticStyle:{"margin-left":"8px"},attrs:{"type":"dashed","icon":"md-add"},on:{"click":_vm.addConditionalRule}},[_vm._v("添加条件规则")])],1)],1),_vm._v(" "),_vm._l((_vm.dataModel.rules),function(rule,idx){return _c('div',{key:idx,staticClass:"rule-row"},[_c('Row',{attrs:{"gutter":12}},[_c('Col',{attrs:{"span":"4"}},[_c('Tag',{attrs:{"color":"blue"}},[_vm._v(_vm._s(rule.type === 'default' ? '默认规则' : '条件规则'))])],1),_vm._v(" "),_c('Col',{attrs:{"span":"12"}},[_c('Input',{attrs:{"placeholder":"目标链接URL"},model:{value:(rule.url),callback:function ($$v) {_vm.$set(rule, "url", $$v)},expression:"rule.url"}})],1),_vm._v(" "),_c('Col',{attrs:{"span":"4"}},[_c('Input',{attrs:{"placeholder":"优先级"},model:{value:(rule.priority),callback:function ($$v) {_vm.$set(rule, "priority", _vm._n($$v))},expression:"rule.priority"}})],1),_vm._v(" "),_c('Col',{staticStyle:{"text-align":"right"},attrs:{"span":"4"}},[_c('Button',{attrs:{"type":"error","size":"small"},on:{"click":function($event){return _vm.removeRule(idx)}}},[_vm._v("删除")])],1)],1),_vm._v(" "),(rule.type==='conditional')?_c('Row',{staticStyle:{"margin-top":"8px"}},[_c('Col',{attrs:{"span":"24"}},[_c('Row',{staticStyle:{"margin-bottom":"6px"},attrs:{"gutter":8}},[_c('Col',{attrs:{"span":"12"}},[_c('Input',{attrs:{"placeholder":"筛选省/市（仅用于查找）"},model:{value:(rule.regionFilter),callback:function ($$v) {_vm.$set(rule, "regionFilter", $$v)},expression:"rule.regionFilter"}})],1),_vm._v(" "),_c('Col',{staticStyle:{"text-align":"right"},attrs:{"span":"12"}},[_c('Button',{attrs:{"size":"small"},on:{"click":function($event){return _vm.expandAllRule(idx, true)}}},[_vm._v("展开全部")]),_vm._v(" "),_c('Button',{staticStyle:{"margin-left":"6px"},attrs:{"size":"small"},on:{"click":function($event){return _vm.expandAllRule(idx, false)}}},[_vm._v("收起全部")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"max-height":"320px","overflow":"auto","border":"1px solid #e8eaec","padding":"8px"}},[_c('Tree',{attrs:{"data":rule.regionTree,"show-checkbox":""},on:{"on-check-change":function($event){return _vm.onRegionTreeChange(idx)}}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('Divider',{attrs:{"dashed":""}})],1)})],2)],1)]),_vm._v(" "),_c('Modal',{attrs:{"width":"300"},model:{value:(_vm.destroyModal),callback:function ($$v) {_vm.destroyModal=$$v},expression:"destroyModal"}},[_c('p',{staticStyle:{"color":"#f60","text-align":"center"},attrs:{"slot":"header"},slot:"header"},[_c('Icon',{attrs:{"type":"information-circled"}}),_vm._v(" "),_c('span',[_vm._v("删除确认")])],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","font-size":"14px"}},[_c('p',[_vm._v("链接："+_vm._s(_vm.destroyData ? _vm.destroyData.name : '-'))]),_vm._v(" "),_c('p',[_vm._v("将被删除且无法恢复，是否继续？")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('Button',{attrs:{"type":"error","size":"large","long":""},on:{"click":function($event){return _vm.destroy(true)}}},[_vm._v("删除")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a20c803c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__ = __webpack_require__(326);
function injectStyle (ssrContext) {
  __webpack_require__(325)
}
var normalizeComponent = __webpack_require__(5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a20c803c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a20c803c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 325:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-stats-view"},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("动态链接访问统计")]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"right","padding":"3px 0"},attrs:{"type":"primary","loading":_vm.loading},on:{"click":_vm.loadStats}},[_vm._v("刷新数据")])],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":8}},[_c('el-card',{staticClass:"stat-card"},[_c('div',{staticClass:"stat-content"},[_c('div',{staticClass:"stat-title"},[_vm._v("链接总数")]),_vm._v(" "),_c('div',{staticClass:"stat-number"},[_vm._v(_vm._s(_vm.stats.totalCount || 0))])])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-card',{staticClass:"stat-card"},[_c('div',{staticClass:"stat-content"},[_c('div',{staticClass:"stat-title"},[_vm._v("启用链接")]),_vm._v(" "),_c('div',{staticClass:"stat-number"},[_vm._v(_vm._s(_vm.stats.activeCount || 0))])])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-card',{staticClass:"stat-card"},[_c('div',{staticClass:"stat-content"},[_c('div',{staticClass:"stat-title"},[_vm._v("停用链接")]),_vm._v(" "),_c('div',{staticClass:"stat-number"},[_vm._v(_vm._s(_vm.stats.inactiveCount || 0))])])])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":24}},[_c('el-card',{staticClass:"stat-card"},[_c('div',{staticClass:"stat-content"},[_c('div',{staticClass:"stat-title"},[_vm._v("累计访问次数")]),_vm._v(" "),_c('div',{staticClass:"stat-number"},[_vm._v(_vm._s(_vm.stats.totalVisits || 0))])])])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12}},[_c('el-card',{staticClass:"stat-card"},[_c('div',{staticClass:"stat-content"},[_c('div',{staticClass:"stat-title"},[_vm._v("默认规则命中")]),_vm._v(" "),_c('div',{staticClass:"stat-number"},[_vm._v(_vm._s((_vm.stats.ruleHits && _vm.stats.ruleHits.defaultHits) || 0))])])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-card',{staticClass:"stat-card"},[_c('div',{staticClass:"stat-content"},[_c('div',{staticClass:"stat-title"},[_vm._v("条件规则命中")]),_vm._v(" "),_c('div',{staticClass:"stat-number"},[_vm._v(_vm._s((_vm.stats.ruleHits && _vm.stats.ruleHits.conditionalHits) || 0))])])])],1)],1),_vm._v(" "),_c('el-divider',[_vm._v("Top 10 链接")]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.topLinks,"stripe":"","loading":_vm.loading}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"shortCode","label":"短码","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"visitCount","label":"访问次数","align":"center"}})],1),_vm._v(" "),_c('el-divider',[_vm._v("URL命中统计")]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.ruleHitsByUrl,"stripe":"","loading":_vm.loading}},[_c('el-table-column',{attrs:{"prop":"url","label":"URL","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"hitCount","label":"命中次数","align":"center"}})],1),_vm._v(" "),_c('el-divider',[_vm._v("规则详细统计")]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.ruleDetails,"stripe":"","loading":_vm.loading}},[_c('el-table-column',{attrs:{"prop":"linkName","label":"链接名称","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ruleType","label":"规则类型","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":scope.row.ruleType === 'default' ? 'primary' : 'success'}},[_vm._v(_vm._s(scope.row.ruleType))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ruleUrl","label":"跳转URL","align":"center","show-overflow-tooltip":true}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ruleRegion","label":"地区条件","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.ruleRegion && scope.row.ruleRegion.length > 0)?_c('span',[_vm._v(_vm._s(Array.isArray(scope.row.ruleRegion) ? scope.row.ruleRegion.join(', ') : scope.row.ruleRegion))]):_c('span',[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"rulePriority","label":"优先级","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"hitCount","label":"命中次数","align":"center"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),

/***/ 387:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_SideMenu__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Navigator__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_TopMenu__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constant__ = __webpack_require__(68);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      errorMessage: '',
      loginSettle: false
    };
  },

  computed: {
    permissions: function permissions() {
      var permissionArr = this.$store.state.user.permissions || [];
      var result = {};
      permissionArr.forEach(function (permission) {
        result[permission] = {
          name: permission,
          menuName: __WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */].permissionMenuMap[permission] || 'unknown menu'
        };
      });
      return result;
    },
    notLogin: function notLogin() {
      var result = true;
      if (this.$store.state.user && this.$store.state.user.userInfo) {
        result = false;
      }
      return result;
    }
  },
  created: function created() {
    var _this = this;

    this.$http.get('sessions').then(function (res) {
      _this.loginSettle = true;
      var data = res.data ? res.data.data[0] : null;
      if (data && data.id && data.username) {
        _this.$store.commit('updateUser', data);
        _this.$router.replace('dashboard');
      } else {
        _this.$store.commit('clearUser');
      }
    }).catch(function () {
      _this.loginSettle = true;
      _this.$store.commit('clearUser');
    });
  },

  components: {
    'login-view': __WEBPACK_IMPORTED_MODULE_3__components_Login__["a" /* default */],
    'side-menu': __WEBPACK_IMPORTED_MODULE_0__components_layout_SideMenu__["a" /* default */],
    'navigator': __WEBPACK_IMPORTED_MODULE_1__components_layout_Navigator__["a" /* default */],
    'top-menu': __WEBPACK_IMPORTED_MODULE_2__components_layout_TopMenu__["a" /* default */]
  }
});

/***/ }),

/***/ 66:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(37);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SideMenu',
  props: ['permissions'],
  data: function data() {
    return {
      menuItemArr: [],
      activeMenu: ''
    };
  },

  computed: {},
  methods: {
    routeTo: function routeTo(route) {
      if (route) {
        var toRoute = '/' + route.split(':').join('/');
        this.$router.push(toRoute);
      }
    }
  },
  created: function created() {
    var _this = this;

    var route = this.$router.currentRoute;
    var path = route.path.substr(1);
    this.menuItemArr = [path.split('/')[0]];
    this.activeMenu = path.split('/').join(':');

    // 路由改变更新menu
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('route-change', function (data) {
      var toRoute = data.to;
      var toPath = toRoute.path.substr(1);
      _this.menuItemArr = [toPath.split('/')[0]];
      _this.activeMenu = toPath.split('/').join(':');
    });
  }
});

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(68);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Navigator',
  data: function data() {
    return {
      itemNames: ['Dashboard']
    };
  },
  created: function created() {
    var _this = this;

    // 路由改变更新导航
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('route-change', function (data) {
      var toRoute = data.to;
      var toPath = toRoute.path.substr(1);
      var pathArr = toPath.split('/');
      var itemNames = [];
      var temp = '';
      pathArr.forEach(function (path) {
        if (temp) {
          temp += ':';
        }
        temp += path;
        itemNames.push(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */].permissionMenuMap[temp] || 'unknown menu');
      });
      _this.itemNames = itemNames;
    });
  }
});

/***/ }),

/***/ 68:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  permissionMenuMap: {
    'dashboard': 'Dashboard',
    'admin': '后台管理',
    'admin:user': '用户管理',
    'admin:role': '角色管理',
    'admin:permission': '权限管理',
    'link': '链接管理',
    'link:dynamic': '动态链接',
    'link:stats': '访问统计'
  }
});

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TopMenu',
  data: function data() {
    return {
      passwordModal: false,
      dataModel: {},
      rules: {
        oldPassword: [{ required: true, message: '旧密码不能为空', trigger: 'blur' }],
        newPassword: [{ required: true, message: '新密码不能为空', trigger: 'blur' }, { type: 'string', min: 6, message: '密码不能少于6位', trigger: 'blur' }],
        newPasswordRepeat: [{ required: true, message: '新密码重复不能为空', trigger: 'blur' }, { type: 'string', min: 6, message: '密码不能少于6位', trigger: 'blur' }]
      }
    };
  },

  methods: {
    action: function action(name) {
      var _this = this;

      if (name === 'logout') {
        this.$http.delete('sessions').then(function () {
          _this.$store.commit('clearUser');
        });
      } else if (name === 'password') {
        this.dataModel = {};
        this.passwordModal = true;
      }
    },
    confirm: function confirm(result) {
      var _this2 = this;

      if (result) {
        this.$refs['dataModel'].validate(function (valid) {
          if (valid) {
            _this2.$http.post('sessions/update-password', {
              oldPassword: _this2.dataModel.oldPassword,
              newPassword: _this2.dataModel.newPassword,
              newPasswordRepeat: _this2.dataModel.newPasswordRepeat
            }).then(function () {
              _this2.$Message.success('修改成功!');
            });
          } else {
            _this2.$Message.error('表单验证失败!');
          }
        });
      } else {
        // TODO - 页面值不会被重置 - https://github.com/iview/iview/issues/970
        this.$refs['dataModel'].resetFields();
      }
    }
  }
});

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    function validateUsername(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入邮箱或用户名'));
      } else {
        callback();
      }
    }

    function validatePassword(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    }

    return {
      tip: true,
      formLogin: {
        username: '',
        password: ''
      },
      ruleCustom: {
        username: [{ validator: validateUsername, trigger: 'blur' }],
        password: [{ validator: validatePassword, trigger: 'blur' }]
      }
    };
  },

  methods: {
    handleSubmit: function handleSubmit(name) {
      var _this = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this.$http.post('sessions', {
            username: _this.formLogin.username,
            password: _this.formLogin.password
          }).then(function (res) {
            var data = res.data.data;
            if (data && data.id && data.username) {
              _this.$store.commit('updateUser', data);
              _this.$router.replace('/dashboard'); // 默认所有后台用户都拥有dashboard权限
            }
          });
        } else {
          _this.$Message.error('信息验证失败，请检查!');
        }
      });
    },
    handleReset: function handleReset(name) {
      this.$refs[name].resetFields();
    }
  }
});

/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      userInfo: this.$store.state.user ? this.$store.state.user.userInfo : {},
      roles: this.$store.state.user ? this.$store.state.user.roles : [],
      permissions: this.$store.state.user ? this.$store.state.user.permissions : []
    };
  }
});

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ = __webpack_require__(38);
var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      allRoles: [],
      dataModel: {},
      rules: {
        username: [{ required: true, message: '姓名不能为空', trigger: 'blur' }, { type: 'string', min: 3, message: '姓名不能少于3位', trigger: 'blur' }],
        password: [{ type: 'string', min: 6, message: '密码不能少于6位', trigger: 'blur' }]
      },
      editModal: false,
      destroyModal: false,
      destroyData: null,
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
      tableColumns: [{
        title: 'ID',
        key: 'id',
        align: 'center'
      }, {
        title: '用户名',
        key: 'username',
        align: 'center'
      }, {
        title: '角色',
        key: 'roles',
        align: 'center',
        render: function render(h, params) {
          var roles = params.row.roles || [];
          var roleNames = roles.map(function (role) {
            return role.name;
          });
          return h('span', {}, roleNames.join(', ') || '-');
        }
      }, {
        title: '状态',
        key: 'disabled',
        align: 'center',
        render: function render(h, params) {
          var disabled = params.row.disabled;
          var color = disabled ? 'error' : 'success';
          var text = disabled ? '禁用' : '启用';
          return h('Tag', {
            props: {
              type: 'dot',
              color: color
            }
          }, text);
        }
      }, {
        title: '创建时间',
        key: 'createdAt',
        align: 'center',
        render: function render(h, params) {
          return h('span', {}, moment(params.row.createdAt).format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '更新时间',
        key: 'updatedAt',
        align: 'center',
        render: function render(h, params) {
          return h('span', {}, moment(params.row.updatedAt).format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '操作',
        key: 'actions',
        align: 'center',
        render: function (h, params) {
          return h('div', [h('Button', {
            props: {
              type: 'primary',
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: function () {
                this.showEdit(params.index);
              }.bind(this)
            }
          }, '编辑'), h('Button', {
            props: {
              type: 'error',
              size: 'small',
              disabled: params.row.username && params.row.username === 'admin'
            },
            on: {
              click: function () {
                this.showDestroy(params.index);
              }.bind(this)
            }
          }, '删除')]);
        }.bind(this)
      }]
    };
  },
  created: function created() {
    var _this = this;

    this.changePage(1);
    this.$http.get('admin/roles?limit=100').then(function (res) {
      var data = res.data.data;
      _this.allRoles = data.rows;
    });
  },

  methods: {
    changePage: function changePage(page) {
      var _this2 = this;

      this.currentPage = page;
      this.$http.get('admin/users?limit=10&offset=' + ((page || 1) - 1) * this.pageSize).then(function (res) {
        var data = res.data.data;
        _this2.tableData = data.rows;
        _this2.totalCount = data.count;
      });
    },
    showCreate: function showCreate() {
      this.dataModel = {};
      var allRoles = this.allRoles;
      _.forEach(allRoles, function (role) {
        role.selected = false;
      });
      this.dataModel.roles = allRoles;
      this.editModal = true;
    },
    showDestroy: function showDestroy(index) {
      this.destroyData = this.tableData[index];
      this.destroyModal = true;
    },
    destroy: function destroy(result) {
      var _this3 = this;

      if (result && this.destroyData) {
        this.$http.delete('admin/users/' + this.destroyData.id).then(function () {
          _this3.$Message.success('删除成功!');
          _this3.refresh();
        });
      }
      this.destroyModal = false;
    },
    refresh: function refresh() {
      if (this.currentPage) {
        this.changePage(this.currentPage);
      }
    },
    showEdit: function showEdit(index) {
      var data = this.tableData[index];
      this.dataModel.id = data.id;
      this.dataModel.username = data.username;
      this.dataModel.enabled = !data.disabled;
      this.dataModel.password = '';
      var allRoles = this.allRoles;
      var userRoles = data.roles;
      _.forEach(allRoles, function (role) {
        role.selected = false;
        _.forEach(userRoles, function (userRole) {
          if (role.name === userRole.name) {
            role.selected = true;
            return false;
          }
        });
      });
      this.dataModel.roles = allRoles;
      this.editModal = true;
    },
    edit: function edit(result) {
      var _this4 = this;

      if (result) {
        this.$refs['dataModel'].validate(function (valid) {
          if (valid) {
            var dataId = _this4.dataModel.id;
            var roles = [];
            _.forEach(_this4.dataModel.roles, function (role) {
              if (role.selected) {
                roles.push(role.name);
              }
            });
            if (dataId) {
              // 编辑
              _this4.$http.put('admin/users/' + dataId, {
                password: _this4.dataModel.password || undefined,
                username: _this4.dataModel.username || undefined,
                disabled: !_this4.dataModel.enabled,
                roles: roles
              }).then(function () {
                _this4.$Message.success('编辑成功!');
                _this4.refresh();
              });
            } else {
              // 新增
              _this4.$http.post('admin/users', {
                password: _this4.dataModel.password || undefined,
                username: _this4.dataModel.username || undefined,
                disabled: !_this4.dataModel.enabled,
                roles: roles
              }).then(function () {
                _this4.$Message.success('新增成功!');
                _this4.refresh();
              });
            }
          } else {
            _this4.$Message.error('表单验证失败!');
          }
        });
      } else {
        // TODO - 页面值不会被重置 - https://github.com/iview/iview/issues/970
        // this.$refs['dataModel'].resetFields();
      }
    }
  }
});

/***/ })

},[245]);


// WEBPACK FOOTER //
// static/js/app.12d6c8ba4ca89a41c47b.js